import React, { useCallback } from 'react';
import { Box, Field, FlexControlledForm } from '@common-fe/common-fe';

import { useEmployerTerminationHsaTransferFields } from './hooks/useEmployerTerminationHsaTransferFields';

interface Props {
    handleChangeValues?: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    values: any,
    fields: Field[],
    setFieldsAreFilled?: (val: boolean) => void,) => void;
  isSubmit?: boolean;
  setSetup?: (value: boolean) => void;
  defaultHsaTransferOfAssets?: string;
  viewMode?: boolean;
}

export const EmployerTerminationHsaTransferForm: React.FC<Props> = ({
  handleChangeValues,
  isSubmit,
  setSetup,
  defaultHsaTransferOfAssets,
  viewMode,
}) => {
  const fields = useEmployerTerminationHsaTransferFields(defaultHsaTransferOfAssets, viewMode);

  const handleChangeDateValue = useCallback((values: object) => {
    if (handleChangeValues) handleChangeValues(values, fields, setSetup);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box data-testid="EmployerTerminationHsaTransferForm_container" round="container1Round" background="canvas">
      <FlexControlledForm
        fields={fields}
        editMode={!viewMode}
        showError={isSubmit}
        onChangeValues={handleChangeDateValue}
        isModalType
      />
    </Box>
  );
};
